import { OnInit, ChangeDetectorRef, AfterContentChecked, OnDestroy, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

declare var $: any;
export class BaseComponent implements OnInit, OnDestroy, AfterContentChecked {
  public model: any = {};
  public modelFilter: any = {};
  public user: any = {};
  public message: any;
  public typeModal = 'add';
  public modalRef: any;
  public modalRef1: any;
  public modalRef2: any;
  public modelDisplay: any = [];
  public modelContent: any = {};
  public is_loading = false;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    this.user = JSON.parse(localStorage.getItem('User')) || {};
  }

  ngOnInit(): void {}

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  ngOnDestroy(): void {}

  protected openModal(template: ElementRef, config?: any, item?: any, options?: any, index = 0): void {
    this.message = null;
    this.model = item ? item : {};
    if (options) {
      if (options.modelContent) {
        this.modelContent = options.modelContent;
      }
      if (options.modelDisplay) {
        this.modelDisplay = options.modelDisplay;
      }
    }
    if (index === 0) {
      this.modalRef = this.modalService.show(template, config);
    }
    if (index === 1) {
      this.modalRef1 = this.modalService.show(template, config);
    }
    if (index === 2) {
      this.modalRef2 = this.modalService.show(template, config);
    }
  }

  protected closeModal(index = 0): void {
    if (index === 0) {
      this.modalRef.hide();
    }
    if (index === 1) {
      this.modalRef1.hide();
    }
    if (index === 2) {
      this.modalRef2.hide();
    }
  }

  protected throwError(
    message = 'Đã xảy ra lỗi vui lòng thử lại sau!',
    tittle = 'Thông báo',
    timeOut = 4000,
    data?: any
  ): void {
    this.toastr
      .error(message, tittle, {
        timeOut: timeOut,
        positionClass: 'toast-bottom-right',
      })
      .onTap.subscribe(() => {
        this.handleToastTap(data);
      });
  }

  protected throwWarning(message = 'Cảnh báo rủi ro!', tittle = 'Cảnh báo', timeOut = 4000, data?: any): void {
    this.toastr
      .warning(message, tittle, {
        timeOut: timeOut,
        positionClass: 'toast-bottom-right',
      })
      .onTap.subscribe(() => {
        this.handleToastTap(data);
      });
  }

  protected throwSuccess(message = 'Xử lý thành công!', tittle = 'Thông báo', timeOut = 4000, data?: any): void {
    this.toastr.success(message, tittle, {
      timeOut: timeOut,
      positionClass: 'toast-bottom-right',
    });
  }

  protected throwInfo(message = 'Thông báo!', tittle = 'Thông báo', timeOut = 4000, data?: any): void {
    this.toastr
      .info(message, tittle, {
        timeOut: timeOut,
        positionClass: 'toast-bottom-right',
      })
      .onTap.subscribe(() => {
        this.handleToastTap(data);
      });
  }

  protected handleToastTap(event: any): void {}

  protected setLoading(isLoading = true): void {
    this.is_loading = isLoading;
    if (!isLoading) {
      if (typeof (window as any).hideGlobalLoading === 'function') {
        (window as any).hideGlobalLoading();
      }
    } else {
      if (typeof (window as any).showGlobalLoading === 'function') {
        (window as any).showGlobalLoading();
      }
    }
    this.changeDetector.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/base.component.ts